// libs
import { createContext } from 'react';
import { INITIAL_CONTEXT } from './initial-context.constant';

export const LocalStorageContext = createContext<unknown>(INITIAL_CONTEXT);

export default LocalStorageContext;
